import { appConstants } from "../helpers/constants";

const initialState = {
  accounts: [],
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.UPDATE_ACCOUNT_LIST: 
      return {
        ...state,
        accounts: action.accounts,
        isLoading: false,
      };
    case appConstants.REQUESTING: 
      return {
        ...state,
        isLoading: true,
      };      
    case appConstants.ERROR_OCCURED: 
      return {
        ...state,
        isLoading: false,
        error: action.error
      };      

    default:
      return state;
  }
};

export default accountReducer;
